import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import Toolbar from './img/Toolbar.png'

export default class ToolbarAction extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">数字地球工具栏操作</div>
        <div className="main-window-content">工具栏分作三区域，对三维球进行操作</div>
        <img src={Toolbar} className="main-window-img"></img>
      </div>
    )
  }
}
